import { BaseService } from './base';
import { APIPath } from '../constants/api';

class List {
  country = () => BaseService.localFiles('/country.json');

  timezone = () => BaseService.localFiles('/timezone.json');

  itemHSCode = () => BaseService.get(APIPath.itemHSCodes);
}

const ListService = new List();
Object.freeze(ListService);
export default ListService;
